import React, { useState, Fragment } from 'react';
import { useTranslate } from 'react-admin';

import { Drawer, CreateButton } from '~/components';
import { CreateForm } from '~/components/ra';
import BankAccountForm from './BankAccountForm';
import { l } from './BankAccountList';

const BankAccountCreate = (props: any) => {
  const { permissions, resource } = props;
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const translate = useTranslate();
  const t = (key: string): string => translate(l(key));

  return (
    <Fragment>
      <CreateButton
        variant='add'
        onClick={handleOpen}
        disabled={!permissions?.includes('bank.account.create')}
      />
      <Drawer heading={t('addBank')} open={open} onClose={handleClose}>
        <CreateForm resource={resource} closeParent={handleClose}>
          <BankAccountForm />
        </CreateForm>
      </Drawer>
    </Fragment>
  );
};

export default BankAccountCreate;
